import {SocialPublicationList, SocialPublicationRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {SOCIAL_PROVIDER, SOCIAL_PUBLICATION_STATUS} from "../labels";
import {Link, TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import dayjs from "dayjs";

export const SocialPublicationListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<SocialPublicationList> = {
        title: "Publicaciones",
        onClick: "/app/admin/marketing/social-publication",
        headers: [
            {title: "Red"},
            {title: "Estado"},
            {title: "Id externo"},
            {title: "Enlace"},
            {title: "Publicado"},
        ],
        decorator: (bean: SocialPublicationList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>{bean.provider ? (SOCIAL_PROVIDER[bean.provider] ?? bean.provider) : "—"}</TableCell>
                <TableCell>{bean.status ? <SoftChip label={SOCIAL_PUBLICATION_STATUS[bean.status]?.label ?? bean.status} tone={SOCIAL_PUBLICATION_STATUS[bean.status]?.tone ?? "neutral"}/> : "—"}</TableCell>
                <TableCell>{bean.externalPostId ?? "-"}</TableCell>
                <TableCell onClick={(e) => e.stopPropagation()}>
                    {bean.permalink
                        ? <Link href={bean.permalink} target="_blank" rel="noopener">Ver publicación</Link>
                        : "-"}
                </TableCell>
                <TableCell>{bean.publishedAt ? dayjs(bean.publishedAt).format("DD/MM/YYYY HH:mm") : "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SocialPublicationRestControllerApiFactory);
            return ctrl.pageSocialPublication(currentPage, size, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
